import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageWithWebp',
  props: {
	src: {
		type: String,
		required: true
	},
	srcWebp: {
		type: String,
		default: ""
	},
	alt: {
		type: String,
		default: ""
	},
	lazy: {
		type: Boolean,
		default: false
	}
},
  setup(__props) {



return { __sfc: true, }
}

})